import { Action, Reducer } from '@reduxjs/toolkit';

type ReducersMapObject = {
  [key: string]: Reducer<any, Action<string>>;
};

export const createRootReducer = (apiModules: {
  [key: string]: {
    reducerPath: string;
    reducer: Reducer<any, Action<string>>;
  };
}) => {
  const apiReducers: ReducersMapObject = {};

  Object.keys(apiModules).forEach((key) => {
    const apiModule = apiModules[key];

    // Avoid duplicates and add to the reducer map only if they are unique
    if (
      apiModule?.reducerPath &&
      apiModule?.reducer &&
      !apiReducers[apiModule.reducerPath]
    ) {
      apiReducers[apiModule.reducerPath] = apiModule.reducer;
    }
  });

  return apiReducers;
};
